import type { ColumnsType } from "antd/es/table";

interface Product {
  asin: string;
  sku: string;
  productTitle: string;
  quantity: number;
}

interface ShipmentOrder {
  soNumber: string;
  shipmentNumber: string;
  status: string;
  freightMethod: string;
  shipmentCost: string;
  issueDate: string;
  shipmentDate: string;
  estDeliveryDate: string;
  actDeliveryDate: string;
  destination: string;
  shipFrom: string;
  purchaseOrderNumber: string;
  products: Product[];
}

export const columns: ColumnsType<Product> = [
  { title: "ASIN", dataIndex: "asin" },
  { title: "SKU", dataIndex: "sku" },
  { title: "Product title", dataIndex: "productTitle" },
  { title: "Quantity", dataIndex: "quantity" },
];

export const shipmentOrders: ShipmentOrder[] = [
  {
    soNumber: "92392",
    shipmentNumber: "101",
    status: "Closed",
    freightMethod: "Air",
    shipmentCost: "£3,500",
    issueDate: "01.01.2024",
    shipmentDate: "03.01.2024",
    estDeliveryDate: "05.01.2024",
    actDeliveryDate: "05.01.2024",
    destination: "UK, Amazon UK main",
    shipFrom: "Super supplement",
    purchaseOrderNumber: "73292",
    products: [
      {
        asin: "B0D5MNJWR9",
        sku: "KJG85903G",
        productTitle: "InoPro Teeth Whitening Strips…",
        quantity: 20_000,
      },
      {
        asin: "B0D5MNJWV7",
        sku: "KJG85903G",
        productTitle: "InoPro Natural Teeth Whitening…",
        quantity: 10_000,
      },
    ],
  },
  {
    soNumber: "92393",
    shipmentNumber: "102",
    status: "In transit",
    freightMethod: "Sea",
    shipmentCost: "£7,200",
    issueDate: "12.02.2024",
    shipmentDate: "16.02.2024",
    estDeliveryDate: "20.03.2024",
    actDeliveryDate: "-",
    destination: "DE, Amazon DE main",
    shipFrom: "Super supplement",
    purchaseOrderNumber: "73293",
    products: [
      {
        asin: "B0D5MNJWR9",
        sku: "KJG85903G",
        productTitle: "InoPro Teeth Whitening Strips…",
        quantity: 20_000,
      },
      {
        asin: "B0D5MNJWV7",
        sku: "KJG85903G",
        productTitle: "InoPro Natural Teeth Whitening…",
        quantity: 10_000,
      },
    ],
  },
  {
    soNumber: "92394",
    shipmentNumber: "103",
    status: "Open",
    freightMethod: "Road",
    shipmentCost: "£800",
    issueDate: "05.03.2024",
    shipmentDate: "-",
    estDeliveryDate: "-",
    actDeliveryDate: "-",
    destination: "FR, Amazon FR main",
    shipFrom: "Super supplement",
    purchaseOrderNumber: "73294",
    products: [
      {
        asin: "B0D5MNJWR9",
        sku: "KJG85903G",
        productTitle: "InoPro Teeth Whitening Strips…",
        quantity: 20_000,
      },
      {
        asin: "B0D5MNJWV7",
        sku: "KJG85903G",
        productTitle: "InoPro Natural Teeth Whitening…",
        quantity: 10_000,
      },
    ],
  },
];
